import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { Collapse } from '@material-ui/core';
import { MainMenuItem, SubMenuItem } from 'src/components/MenuItems';

import pages from './pages';

const navigateToPage = page => {
  navigate(`/me${page.link}`, { state: { name: page.name } });
};

const selectedPage = (pathname, link) => {
  return pathname.split('/me').pop() === link;
};

export default function NavigationMenus() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return pages.map(page => (
    <React.Fragment key={page.name}>
      <MainMenuItem
        selected={selectedPage(pathname, page.link)}
        button
        onClick={() => {
          if (page.link) {
            navigateToPage(page);
          } else {
            setOpen(!open);
          }
        }}
      >
        {page.icon}
        {page.name}
      </MainMenuItem>
      {page.subPages && (
        <Collapse in={open || pathname.match('settings')} timeout="auto" unmountOnExit>
          {/* <List component="div" disablePadding> */}
          {page.subPages.map(ele => (
            <SubMenuItem
              selected={selectedPage(pathname, ele.link)}
              key={ele.name}
              onClick={() => {
                navigateToPage(ele);
              }}
            >
              {ele.name}
            </SubMenuItem>
          ))}
          {/* </List> */}
        </Collapse>
      )}
    </React.Fragment>
  ));
}
